module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('p', {
    staticClass: "f18 pb20"
  }, [_vm._v("主账号信息")]), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_vm._v("\n            账号类型：\n            "), (_vm.detail.type == 1) ? _c('span', [_vm._v("学校")]) : _vm._e(), _vm._v(" "), (_vm.detail.type == 2) ? _c('span', [_vm._v("公司")]) : _vm._e(), _vm._v(" "), (_vm.detail.type == 3) ? _c('span', [_vm._v("加盟")]) : _vm._e()]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_vm._v("账号名称：" + _vm._s(_vm.detail.true_name))]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_vm._v("\n            登录账号：" + _vm._s(_vm.detail.mp) + "\n        ")])], 1), _vm._v(" "), _c('div', {
    staticClass: "line pt10"
  }), _vm._v(" "), _c('p', {
    staticClass: "f18 pb20"
  }, [_vm._v("子账号管理")]), _vm._v(" "), _c('el-row', {
    staticClass: "pb10"
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "size": "mini"
    },
    on: {
      "click": function($event) {
        return _vm.addChild()
      }
    }
  }, [_vm._v("新增")])], 1), _vm._v(" "), _c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.tableData,
      "border": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "id",
      "label": "序号",
      "width": "120"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "account",
      "label": "登录手机号",
      "width": "160"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "true_name",
      "label": "用户名",
      "show-overflow-tooltip": true,
      "width": "200"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "created_at",
      "label": "创建时间",
      "width": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "",
      "label": "操作",
      "fixed": "right"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "type": "text",
            "size": "mini"
          },
          on: {
            "click": function($event) {
              return _vm.addAuth(scope.row)
            }
          }
        }, [_vm._v("授权")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "text",
            "size": "mini"
          },
          on: {
            "click": function($event) {
              return _vm.resetPwd(scope.row)
            }
          }
        }, [_vm._v("重置密码")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "text",
            "size": "mini"
          },
          on: {
            "click": function($event) {
              return _vm.delChild(scope.row)
            }
          }
        }, [_vm._v("删除")])]
      }
    }])
  })], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "新增子账号",
      "visible": _vm.dialogFormVisible,
      "width": "30%"
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogFormVisible = $event
      }
    }
  }, [_c('el-form', {
    ref: "form",
    attrs: {
      "size": "mini",
      "model": _vm.form,
      "rules": _vm.rules,
      "label-width": "80px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "手机号",
      "prop": "child_account"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "maxlength": "11"
    },
    model: {
      value: (_vm.form.child_account),
      callback: function($$v) {
        _vm.$set(_vm.form, "child_account", $$v)
      },
      expression: "form.child_account"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "用户名",
      "prop": "child_name"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "maxlength": "15"
    },
    model: {
      value: (_vm.form.child_name),
      callback: function($$v) {
        _vm.$set(_vm.form, "child_name", $$v)
      },
      expression: "form.child_name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": ""
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "size": "mini"
    },
    on: {
      "click": function($event) {
        return _vm.submitForm('form')
      }
    }
  }, [_vm._v("保存")])], 1)], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "子账号授权",
      "visible": _vm.dialogFormVisible1,
      "width": "50%"
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogFormVisible1 = $event
      }
    }
  }, [(_vm.account_type == 4) ? _c('el-tree', {
    ref: "tree",
    attrs: {
      "data": _vm.menus,
      "show-checkbox": "",
      "default-expand-all": "",
      "node-key": "district_id",
      "highlight-current": "",
      "props": _vm.defaultProps2
    }
  }) : _c('el-tree', {
    ref: "tree",
    attrs: {
      "data": _vm.menus,
      "show-checkbox": "",
      "default-expand-all": "",
      "node-key": "rule_id",
      "highlight-current": "",
      "props": _vm.defaultProps
    }
  }), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "margin-left": "50px"
    },
    attrs: {
      "type": "primary",
      "size": "mini"
    },
    on: {
      "click": function($event) {
        return _vm.submitAuth()
      }
    }
  }, [_vm._v("保存")])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-18184f4e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./vue/views/passport/account.vue
// module id = 853
// module chunks = 0